__webpack_require__.p = "/assets/turbo/06d6d8c7/baurde/_next/";